/** 支付状态：与列表筛选 useFilterHeader、订单详情步骤条共用，避免各处写死枚举 */
export interface PayStatusOption {
  label: string
  value: string | null
}

/**
 * 后端 orderInfo.payStatus 权威枚举：
 * - 0  未支付
 * - 10 支付失败
 * - 20/21/22 支付成功
 * - 30 已退款（支付成功后发生退款）
 */
export const payStatusList: PayStatusOption[] = [
  { label: '全部', value: null },
  { label: '未支付', value: '0' },
  { label: '支付失败', value: '10' },
  { label: '支付成功', value: '20' },
  { label: '已退款', value: '30' },
]

/** 列表「近30天」等小范围筛选：只暴露成功/已退款 */
export const payStatusListSmall: PayStatusOption[] = [
  { label: '支付成功', value: '20' },
  { label: '已退款', value: '30' },
]

/** 支付成功的所有 payStatus 取值（后端含 20/21/22 三个成功码） */
const PAY_SUCCESS_CODES = new Set(['20', '21', '22'])

/** 支付结果语义，供详情页步骤条第一个节点判定状态与文案 */
export type PayResult = 'unpaid' | 'fail' | 'success' | 'refunded'

/** 由 payStatus 推断支付结果；无法识别时返回 unpaid（最弱态，进度不推进） */
export function resolvePayResult(val: unknown): PayResult {
  if (val === null || val === undefined || val === '') return 'unpaid'
  const s = String(val)
  if (s === '10') return 'fail'
  if (s === '30') return 'refunded'
  if (PAY_SUCCESS_CODES.has(s)) return 'success'
  return 'unpaid'
}

/** 详情页步骤条第一个节点的展示文案 */
export function getPayStepTitle(result: PayResult): string {
  switch (result) {
    case 'fail':
      return '支付失败'
    case 'unpaid':
      return '待支付'
    default:
      // success / refunded 都表示已支付成功
      return '支付成功'
  }
}
